import { useNavigate } from "react-router-dom";
import Button from "../Buttons/Button";
import { MdArrowBack } from "react-icons/md";
import { useEffect, useState } from "react";
import { scrollToElement } from "../../utils/utils";

interface BackButtonProps {
    onBeforeNavigate?: (previousData: Record<string, string | number | boolean>) => void; // opcional
}

const BackButton = ({
    onBeforeNavigate,
}: BackButtonProps) => {
    const navigate = useNavigate();

    const [previousData, _setPreviousData] = useState<Record<string, string | number | boolean> | null>(() => {
        const stored = sessionStorage.getItem("previous");
        if (stored) {
            try {
                return JSON.parse(stored);
            } catch {
                console.error("Error parseando previous:", stored);
                return null;
            }
        }
        return null;
    });

    const handleClick = () => {
        if (!previousData) return;

        if (onBeforeNavigate) {
            onBeforeNavigate(previousData);
        }

        const { path, label, scrollTargetId, includeQuery, ...queryData } = previousData;

        const queryParams = new URLSearchParams();

        if (includeQuery !== false) {
            Object.entries(queryData).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    queryParams.set(key, String(value));
                }
            });
        }

        const query = queryParams.toString();
        const url = `/monitor${path ?? ""}${query ? `?${query}` : ''}`;

        navigate(url);

        if (scrollTargetId) {
            scrollToElement(scrollTargetId.toString(), -25, 1500);
        }

        sessionStorage.removeItem("previous");
    };

    if (!previousData) return null;

    return (
        <Button
            onClick={handleClick}
            label={previousData.label.toString() ?? ''}
            as='link'
            icon={MdArrowBack}
            showIconLeft={true}
            showIconRight={false}
            className='border border-system-light-50 text-system-light-40 mb-4'
            iconSize={18}
            variant="outline-dark"
        />
    );
};

export default BackButton;